// ---------- demo sheet ----------
// La feuille de repli : celle qu'on ouvre quand le catalogue est injoignable, pour qu'il y ait
// toujours quelque chose à peindre. C'est une grille FIGÉE, pas une image convertie au
// lancement — depuis que la conversion appartient à l'admin (cf. DEPLOY.md), le jeu ne sait
// plus transformer une photo, et il n'a plus à le savoir : il joue des grilles qu'on lui donne.
//
// Produite une fois par le pipeline de l'admin à partir du visage dessiné au canevas de
// l'ancien `demoImage()`, en alphabet « Motifs » sur 72 cases de côté — assez pour que le sujet
// se lise, assez peu pour tenir en 5184 caractères ici.
//
// Encodage : un caractère en base 36 par case, en lecture ligne par ligne. Les codes montent à
// 17 (motifsTrait), donc une lettre suffit et le fichier reste lisible dans un diff.

const W = 72;
const H = 72;

const PACKED =
  '002002002002002002002002002002002002002002002002002002002002002002002002200200200200200200200200' +
  '200200200200200200200200200200200200200200200200020020020020020020020020020020020020020020020020' +
  '020020020020020020020020002002002002002002002002002003003003003009002002002002002002002002002002' +
  '200200200200200200200200200800900000000000300900200200200200200200200200020020020020020020020020' +
  '080000071111111160000090020020020020020020020020002002002002002002002008000011111111111111110009' +
  '002002002002002002002002200200200200200200200800001111111111111111111100090200200200200200200200' +
  '020020020020020020020070711111111111111111111116000020020020020020020020002002002002002002008001' +
  '111111111111111111111111100902002002002002002002200200202020200202080011111111111111111111111111' +
  '110000200200202020200200020020020000020200000111111111111111111111111111111060020020200000020020' +
  '002002002022002008071111111111111111111111111111111100902002002022002020200200200200200800011111' +
  '111111111111111111111111111110000200200200200200020020020020020020111111111111183003000391111111' +
  '111111020020020020020020002002002002008007111111111118080220222090911111111111609002002002002002' +
  '200200200200200001111111111808070303030402009111111111100900200200200200020020202020080011111111' +
  '110807033030303303650911111111110090020020020020002002000002007011111111108053030303303030080901' +
  '111111110090202002002002200200202020800111111111080303030303030303303090111111111009000200200200' +
  '020020020020000111111118073080303030030300903060911111111000202020020020002002002002001111111180' +
  '700803030030303030909030091111111105000002002020200200200200401111111103080803003003000303090908' +
  '301111111100902200202002020020020020001111111080808080030300303000900900400111111140020020020020' +
  '002002002004011111111050800800800030030090090090905911111140002002002000200200200200011111110808' +
  '080080080003000303009090903011111110500200200202020020020080011111110500808003003000030000900900' +
  '900511111110090020020020002002002040511111180508000300000030000300030090090091111114002002002000' +
  '200200202000511111109000900000000000300000000002090801111114002020200202020020200200511111100804' +
  '072211114000000511112260009001111114050000020020002002002040111111105080011133000090000000331110' +
  '500401111111002020202000200200200000111111400000000000000000000000000000090090111111000200000202' +
  '020020020200111111080804000721000000000000210000509005111111050020220020002002002040111111008000' +
  '407111100000000001111100000900111111002002002000200200200000111111050800001111100000000001111100' +
  '909040111111000200200202020020020200111111000040000111800000000009111000000000111111050020020020' +
  '002002002040511111050400400000000000000000000000505040111111002002002002200200200200511111008000' +
  '000000000007000000000000000900111114000200200200020020020040511111070040040000000007600000000050' +
  '505005111110050020020020002002002000011111009000000000000005400000000000000300111110050202002002' +
  '200200200204011111400040000000000005400000000000500005111110002000200200020020202000011111105000' +
  '400000000072060000000050005001111110500202020020002002000204001111100040004000000093380000000000' +
  '500401111180020000002002200200202000401111100800400000000000000000000070009001111100002020200200' +
  '020020020020001111160000000000000000000000000000050071111100500202020020002002002020600111110506' +
  '006000000000000000007005000011111000502000020202200200200006000111110000600000000000000000000000' +
  '707011111007000202000000020020020200400911111050000600400000000000070070000111118000202002020220' +
  '002002002020060011111000600000000000000000000007070111110070020020020002200200200200400001111100' +
  '206060010000000016007070001111100005002002002020020020020020060001111160000000911112111110070008' +
  '071111100700200200200200002002002002006000111110606060000311313000000700011111000070020020020020' +
  '200200200200200600011111000600020000000002070070111110007002002002002002020020020020020060091111' +
  '100020200000000200020001111180000200200200200200002002020202002006009111116009002020200020800711' +
  '111800070020020020020020200200200000200200000011111600030002020200007111110000702002002002002002' +
  '020020020202020020600001111110004030003002011111100070000200200200200200002002002020002002060600' +
  '111111160000000071111111007007020020202020020020200200200002020200006000001111111111111111111100' +
  '000700202002000020202002020020020200200020200606000011111111111111110000070020000200202002000200' +
  '002002020020020200202000060000911111111118000070700200220020020200202020200200200202002002000206' +
  '006020000000000000002002002002002002000020000002020020020000200200202002060000200020020020200700' +
  '200200200200202002022020002002002020020020020020002020020200200200020020020020020020020200200002' +
  '200200200202002002002002020002000020020020202002002002002002002020020200020020020020200200200200' +
  '200200202002002000000200200200200200200002002020002002002000020020020020020020020200200202020020' +
  '020020020020020200200002200200200202002002002002002002000020020020202002002002002002020020020200' +
  '020020202002020200200200200200202002002000002020200200200202002002002020002002000200200020020020' +
  '020020202020200202020000020020202000200200200020200200202020020202002002002002000200020020200202' +
  '002002000202020020020200020020020002002000200200200200202002002000020200202020020020002002020020';

/** La grille de démonstration, décompressée à l'appel — une seule fois par partie. */
export function demoTarget(): {
  gridW: number;
  gridH: number;
  alphabetId: string;
  target: number[][];
} {
  const target: number[][] = [];
  for (let r = 0; r < H; r++) {
    const row: number[] = [];
    for (let c = 0; c < W; c++) row.push(parseInt(PACKED[r * W + c], 36));
    target.push(row);
  }
  return { gridW: W, gridH: H, alphabetId: 'motifs', target };
}
